/**
 * Collection Tabs Showcase
 * Swiper is loaded globally via theme.liquid, so no dynamic asset loading needed.
 * - Tab buttons switch which panel/swiper is visible.
 * - Each panel gets its own Swiper instance, initialized lazily
 *   the first time its tab is opened (avoids computing widths
 *   on hidden elements, which Swiper can't measure correctly).
 */

(function () {
  function initPanelSwiper(panel) {
    var swiperEl = panel.querySelector('[data-cts-swiper]');
    var scrollbarEl = panel.querySelector('[data-cts-scrollbar]');

    if (!swiperEl || swiperEl.swiper || !window.Swiper) return;

    new window.Swiper(swiperEl, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      freeMode: true,
      grabCursor: true,
      watchOverflow: true,
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        dragSize: 100
      },
      breakpoints: {
        750: {
          slidesPerView: 2.15,
          spaceBetween: 24
        },
        990: {
          slidesPerView: 2.30,
          spaceBetween: 24,
          freeMode: false
        }
      }
    });
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('.collection-tabs__tab');
    var panels = root.querySelectorAll('.collection-tabs__panel');

    if (!tabs.length) return;

    var activePanel = root.querySelector('.collection-tabs__panel.is-active');
    if (activePanel) initPanelSwiper(activePanel);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-tab-index');

        tabs.forEach(function (t) {
          var isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-tab-panel') === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;

          if (isActive) {
            var swiperEl = panel.querySelector('[data-cts-swiper]');
            if (swiperEl && swiperEl.swiper) {
              swiperEl.swiper.update();
            } else {
              initPanelSwiper(panel);
            }
          }
        });
      });
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.collection-tabs');
    sections.forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.collection-tabs');
    if (section) initTabs(section);
  });
})();